<template>
  <div>
    <div class="das_top_cont payment_record_root">
      <div class="history_box account_input">
        <div class="accountright_cont_box">

          <div class="flex_center_between_box payment_record_root_top" style="">
            <h2 class="payment_record_root_top_title">{{ $t('AccountCenterMenu.PaymentRecords') }}</h2>
            <div style="display: flex;">
              <button class=" flex_center payment_record_root_top_button"
                :class="Dowload.length == 0 ? 'btn_disabled' : 'btn_blue'" :disabled="Dowload.length == 0" @click="ReportError = true">

                <span> {{ $t('BillingandPayment.Contactus') }}</span>
                <!-- <a v-else  style="color: #fff;"  :href="'mailto:service@csibizinfo.com?subject=information need to correct&body=Customer service, hello: %0D%0Aand If you have any questions about the selected single payment order or multiple payment %0D%0Aand orders, please enter your questions below：'+Dowload[0]?.email+Dowload[0]?.createTime+Dowload[0]?.paymentAmount+'%0D%0Aand Please help to handle it as soon as possible. thank you' ">
           
            </a> -->
              </button>
              <button class="flex_center todo_btn payment_record_root_top_button" @click="getInvoicePdfAddress()"
                :class="Dowload.length == 0 ? 'btn_disabled' : 'btn_blue'" :disabled="Dowload.length == 0">
                {{ $t('BillingandPayment.DownloadInvoice') }}
              </button>
            </div>
          </div>
          <div class="his_sel_box common_checkbox" style="width: 100%;display: flex;flex-direction: column;flex: 1;">
            <el-table class="spec_table payment_record_root_table" :data="yourUsagelist" style="width: 100%"
              @selection-change="handleSelectionChange" empty-text="No Data">
              <el-table-column type="selection" :selectable="selectableRows" width="55" :aria-disabled="true">
              </el-table-column>
              <el-table-column prop="createTime" :label="$t('MyDatabase.Date')" align="left">
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.createTime }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="paymentAmount" :label="$t('BillingandPayment.UserAccount')" align="left"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.email }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="paymentAmount" :label="$t('BillingandPayment.PaymentAmount')" align="left"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="table-content " style="">
                    {{ scope.row.paymentAmount }}
                  </div>
                </template>
              </el-table-column>

            </el-table>
            <div class="page_i_box" v-if="yourUsagelist.length > 0">
              <Page :totalFont="true" :total="page.total" :pageSize.sync="page.pageSize" :currentPage="page.pageNo"
                @onPageChange="onPageChangeList"></Page>

              <div class="search_rsult_txt line_2">{{ page.pageNo }}-{{ page.pageSize }} of over 
                 <span class="foundOverNum" :style="{'color': $store.state.app.themeColor}">&nbsp;{{ page.total | FilterNum }}&nbsp;</span>
                results for "{{ $t('AccountCenterMenu.PaymentRecords') }}"</div>
            </div>
            <!-- <div v-show="this.page.total>this.page.pageSize" style="text-align: center; padding-top: 20px">
              <span class="contclass show_All" @click="apptablelist">Show More</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
    <Reporterror :showReport="ReportError" @closeReportDialog="closeDialog($event)"></Reporterror>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import Reporterror from "../../../components/reportProblems/index.vue";
import { getUserRechargesPage, getInvoicePdfAddress } from "@/api/userApi";
import ReLogin from "../../../components/ReLogin.vue";
import Page from '@/components/page/index.vue';
export default {
  mixins: [mixins1],
  components: {
    ReLogin,
    Reporterror,
    Page
  },
  data() {
    return {
      reLoginVis: false,
      ReportError: false,
      value1: "",
      CategoryVal: "",
      yourUsagelist: [],
      window: window,
      page: {
        pageSize: 5,
        pageNo: 1,
      },
      Dowload: []
    };
  },
  beforeDestroy() { },
  destroyed() { },
  mounted() {
    this.getgetUserActionLogPage();
  },

  methods: {
    closeDialog(value) {
      this.ReportError = value;
    },
    selectable(row) {

      // 这里可以根据行数据的条件返回 true 或 false
      return row.userInvoiceId == null; // 例如，只有价格小于 250 的行可以被选中
    },
    getgetUserActionLogPage() {
      getUserRechargesPage({
        // email: this.CategoryVal,
        // actualAmount: this.CategoryVal1,
        // startTime: this.datePicker == null ? "" : this.datePicker[0],
        // endTime: this.datePicker == null ? "" : this.datePicker[1],
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      }).then((res) => {

        if (res.code == 200) {
          this.yourUsagelist = res.data.rows;
          this.page.total = res.data.total
        } else {
          this.yourUsagelist = [];
        }
      }).catch(err => {
        this.reLoginVis = String(err).includes('403')
      });

    },
    getInvoicePdfAddress() {
      let userInvoiceIdArr = []
      this.Dowload.forEach((item, index) => {
        if (item.userInvoiceId == null) {
          userInvoiceIdArr.push(item.id)
        }

      })

      getInvoicePdfAddress({ ids: userInvoiceIdArr.join(',') }).then(res => {
        if (res.code == 200) {
          window.open(res.data, '_blank');
          this.$router.go(0);

        } else {

          this.$message.error(res.msg);
        }

      })

    },
    handleSelectionChange(val) {
      this.Dowload = val

    },
    selectableRows(row, index) {
      return row.actualAmount;

    },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page
      this.getgetUserActionLogPage();
    },
    currtentPageChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getgetUserActionLogPage()
    },
    apptablelist() {
      this.page.pageSize = this.page.pageSize + 5

      this.getgetUserActionLogPage()
    }

  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 12px;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 16px;
  height: 16px;
}

.das_top_item .item_title {
  font-size: 16px;
  color: #022955;
  margin: 9px 0 9px;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 9px;
  font-size: 16px;

  /* width: 17.142857142857142rem; */
}

.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 4px;
}

.item_txt {
  font-size: 22px;
  text-align: center;
}

.cont_m {
  margin-top: 26px;
  margin-bottom: 70px;
}

.country_box {
  margin-top: 52px;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 18px;
}

.title_txt {
  font-size: 14px;
  font-family: 'Arial Bold';
}

.title_txt img {
  width: 18px;
  margin-right: 7px;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 9px 18px;
  background: #1290c9;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 18px;
}

.btn_blue img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc;
  border-radius: 7px;
  font-size: 14px;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 18px;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0rem 2px 4px 0 rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 54px;
  height: 54px;
  line-height: 68px;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 16px;
  color: #022955;
  margin: 9px 0 9px;
  text-align: center;
}

.top_tab {
  margin-top: 35px;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.jiange {
  color: #cccccc;
  margin: 0 18px;
  font-size: 16px;
  /* font-size: 1.25em; */
}

.contclass {
  font-size: 16px;
  color: #1290c9;
  font-style: normal;
}


/deep/ .el-table th.el-table__cell>.cell {
  font-family: 'Arial Bold';
}

.last-colmun {
  padding: 25px 0;
  border-bottom: 1px solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -26px;
  right: 0rem;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 26px !important;
}

/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 18px;
  color: #8c939d;
  width: 62px;
  height: 62px;
  line-height: 62px;
  text-align: center;
}

/deep/ .avatar {
  width: 62px;
  height: 62px;
  display: block;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 3px;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 14px;
  margin-left: -4px;
  color: #1A2332;
  /* float: left; */
  line-height: 28px;
  position: relative;
  left: 47%;
}

.payment_record_root_top {
  margin-bottom: 20px;
}

.payment_record_root——top_title {
  font-family: 'Arial Bold';
  font-weight: normal;
  font-size: 24px;
  color: #1A2332;
  line-height: 34px;
  text-align: left;
  font-style: normal;
}

.payment_record_root_top_button {
  width: max-content;
  min-width: auto;
  height: 40px;
  border-radius: 10px;
  padding: 0 15px !important;
  font-family: 'Arial';
  font-size: 18px;
  color: #FFFFFF;
  line-height: 34px;
  text-align: center;
  font-style: normal;
}

.payment_record_root_top_button:first-child{
  margin-right: 15px;
}

.payment_record_root_table ::v-deep {
  overflow-y: auto;
  border: none;
  border-collapse: collapse;
}

.payment_record_root_table ::v-deep thead,
.payment_record_root_table ::v-deep .el-table__cell {
  min-height: 50px !important;
  height: 50px !important;
  padding: 0 !important;
}

.payment_record_root_table ::v-deep td,
.payment_record_root_table ::v-deep td.el-table__cell {
  min-height: 60px !important;
  height: 60px !important;
}

.payment_record_root_table ::v-deep .el-table__body-wrapper .el-table__row td:last-child,
.payment_record_root_table ::v-deep .el-table__header-wrapper th:last-child {
  border-right: none !important;
}

.payment_record_root_table::after {
  display: none !important;
}

.payment_record_root_table.el-table {
  overflow: hidden;
}

.payment_record_root_table ::v-deep .el-table__cell:first-child>.cell {
  padding-left: 20px !important;
}

.payment_record_root_table ::v-deep .el-table__body-wrapper .el-table__cell:last-child>.cell {
  padding-right: 100px !important;
}

.payment_record_root_table ::v-deep .el-table__header-wrapper th.el-table__cell:nth-last-child(2)>.cell {
  text-align: center;
  padding-right: 100px !important;
}

.payment_record_root_table.el-table ::v-deep th.el-table__cell>.cell {
  font-family: 'Arial bold';
}

.payment_record_root_table.el-table ::v-deep .cell,
.payment_record_root_table.el-table ::v-deep .cell .table-content {
  font-size: 18px !important;
  line-height: 24px;
  color: #1A2332;
  font-family: 'Arial';
  text-align: left;
  font-style: normal;
}

.payment_record_root_table.el-table ::v-deep .cell .company_link {
  color: #1290C9;
  text-decoration-line: underline;
}

.payment_record_root_table.el-table ::v-deep .cell .el-checkbox__inner {
  width: 20px;
  height: 20px;
}

.payment_record_root_table.el-table ::v-deep .cell .el-checkbox__inner::after {
  width: auto;
  height: auto;
  top: 50%;
  left: 50%;
  background-image: none;
}

::v-deep .el-dialog__body {
  border-radius: 30px;
}

.payment_record_root_top_title {
  font-family: 'Arial Bold';
  font-weight: normal;
  font-size: 24px;
  color: #1290c9;
  line-height: 34px;
  text-align: left;
  font-style: normal;
}

.accountright_cont_box {
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  min-height: calc(100vh - 136px);
}


@media screen and (max-width: 1920px) {
  .das_top_item .item_img img {
    width: 12px;
    height: 12px;
  }

  .das_top_item .item_title {
    font-size: 12px;
    margin: 7px 0 7px;
  }

  .das_top_item .item_group {
    margin-left: 7px;
    font-size: 12px;
  }

  .item_txt {
    font-size: 16px;
  }

  .cont_m {
    margin-top: 20px;
    margin-bottom: 52px;
  }

  .country_box {
    margin-top: 40px;
  }

  .title {
    margin-bottom: 14px;
  }

  .title_txt {
    font-size: 12px;
  }

  .title_txt img {
    width: 14px;
    margin-right: 5px;
  }

  .btn_blue {
    padding: 7px 14px;
    font-size: 14px;
  }

  .btn_blu {
    margin-right: 14px;
  }

  .btn_blue img {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }

  .sel_box /deep/ .el-input__inner {
    border-radius: 5px;
    font-size: 12px;
  }

  .das_top_item {
    padding: 14px;
  }

  .das_top_item .item_img {
    width: 42px;
    height: 42px;
    line-height: 52px;
  }

  .das_top_item .item_title {
    font-size: 14px;
    margin: 7px 0 7px;
  }

  .top_tab {
    margin-top: 26px;
  }

  .jiange {
    margin: 0 14px;
    font-size: 14px;
  }

  .contclass {
    font-size: 14px;
  }

  .last-colmun {
    padding: 18px 0;
  }

  .dingwei {
    top: -20px;
  }

  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 20px !important;
  }

  ::v-deep .avatar-uploader .el-upload {
    border-radius: 4px;
  }

  ::v-deep .avatar-uploader-icon {
    font-size: 16px;
    width: 48px;
    height: 48px;
    line-height: 48px;
  }

  ::v-deep .avatar {
    width: 48px;
    height: 48px;
  }

  .el-date-editor /deep/ .el-range__icon {
    font-size: 12px;
    margin-left: -3px;
    line-height: 22px;
  }

  .payment_record_root_top {
    height: 40px;
    margin-bottom: 15px;
  }

  .payment_record_root——top_title {
    font-size: 18px;
    line-height: 26px;
  }

  .payment_record_root_top_button {
    height: 30px;
    border-radius: 7px;
    font-size: 16px;
    line-height: 26px;
  }

  .payment_record_root_table ::v-deep thead,
  .payment_record_root_table ::v-deep .el-table__cell {
    min-height: 44px !important;
    height: 44px !important;
  }

  .payment_record_root_table ::v-deep td,
  .payment_record_root_table ::v-deep td.el-table__cell {
    min-height: 50px !important;
    height: 50px !important;
  }

  .payment_record_root_table ::v-deep .el-table__cell:first-child>.cell {
    padding-left: 15px !important;
  }

  .payment_record_root_table ::v-deep .el-table__body-wrapper .el-table__cell:last-child>.cell {
    padding-right: 75px !important;
  }

  .payment_record_root_table ::v-deep .el-table__header-wrapper th.el-table__cell:nth-last-child(2)>.cell {
    padding-right: 75px !important;
  }

  .payment_record_root_table.el-table ::v-deep .cell,
  .payment_record_root_table.el-table ::v-deep .cell .table-content {
    font-size: 16px !important;
    line-height: 18px;
  }

  .payment_record_root_table.el-table ::v-deep .cell .el-checkbox__inner {
    width: 15px;
    height: 15px;
  }

  ::v-deep .el-dialog__body {
    border-radius: 22px;
  }

  .payment_record_root_top_title {
    font-size: 20px;
    line-height: 26px;
  }
  
  .accountright_cont_box {
    padding-bottom: 10px;
  }
}

@media screen and (max-width: 1439px) {
  .das_top_item .item_img img {
    width: 12px;
    height: 12px;
  }

  .das_top_item .item_title {
    font-size: 12px;
    margin: 6px 0 6px;
  }

  .das_top_item .item_group {
    margin-left: 6px;
    font-size: 12px;
  }

  .item_txt {
    font-size: 14px;
  }

  .cont_m {
    margin-top: 18px;
    margin-bottom: 46px;
  }

  .country_box {
    margin-top: 34px;
  }

  .title {
    margin-bottom: 12px;
  }

  .title_txt {
    font-size: 12px;
  }

  .title_txt img {
    width: 12px;
    margin-right: 5px;
  }

  .btn_blue {
    padding: 6px 12px;
    font-size: 12px;
  }

  .btn_blu {
    margin-right: 12px;
  }

  .btn_blue img {
    width: 12px;
    height: 12px;
    margin-right: 3px;
  }

  .sel_box /deep/ .el-input__inner {
    border-radius: 5px;
    font-size: 12px;
  }

  .das_top_item {
    padding: 12px;
  }

  .das_top_item .item_img {
    width: 36px;
    height: 36px;
    line-height: 46px;
  }

  .das_top_item .item_title {
    font-size: 12px;
    margin: 6px 0 6px;
  }

  .top_tab {
    margin-top: 24px;
  }

  .jiange {
    margin: 0 12px;
    font-size: 12px;
  }

  .contclass {
    font-size: 12px;
  }

  .last-colmun {
    padding: 16px 0;
  }

  .dingwei {
    top: -17px;
  }

  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 17px !important;
  }

  ::v-deep .avatar-uploader .el-upload {
    border-radius: 3px;
  }

  ::v-deep .avatar-uploader-icon {
    font-size: 14px;
    width: 42px;
    height: 42px;
    line-height: 42px;
  }

  ::v-deep .avatar {
    width: 42px;
    height: 42px;
  }

  .el-date-editor /deep/ .el-range__icon {
    font-size: 12px;
    margin-left: -3px;
    line-height: 18px;
  }

  .payment_record_root_top {
    margin-bottom: 12px;
  }

  .payment_record_root——top_title {
    font-size: 16px;
    line-height: 22px;
  }

  .payment_record_root_top_button {
    height: 26px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 22px;
  }

  .payment_record_root_table ::v-deep thead,
  .payment_record_root_table ::v-deep .el-table__cell {
    min-height: 32px !important;
    height: 32px !important;
  }

  .payment_record_root_table ::v-deep td,
  .payment_record_root_table ::v-deep td.el-table__cell {
    min-height: 40px !important;
    height: 40px !important;
  }

  .payment_record_root_table ::v-deep .el-table__cell:first-child>.cell {
    padding-left: 12px !important;
  }

  .payment_record_root_table ::v-deep .el-table__body-wrapper .el-table__cell:last-child>.cell {
    padding-right: 67px !important;
  }

  .payment_record_root_table ::v-deep .el-table__header-wrapper th.el-table__cell:nth-last-child(2)>.cell {
    padding-right: 67px !important;
  }

  .payment_record_root_table.el-table ::v-deep .cell,
  .payment_record_root_table.el-table ::v-deep .cell .table-content {
    font-size: 14px !important;
    line-height: 16px;
  }

  .payment_record_root_table.el-table ::v-deep .cell .el-checkbox__inner {
    width: 12px;
    height: 12px;
  }

  ::v-deep .el-dialog__body {
    border-radius: 20px;
  }


  .payment_record_root_top_title {
    font-size: 16px;
    line-height: 18px;
  }

  .accountright_cont_box {
    padding-bottom: 0;
    min-height: calc(100vh - 126px);
  }
}
</style>